import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { SectionTitle, Card, Field, Area, SaveButton } from "../ui";

export default function SeoSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/seo-settings").then((res) => setS(res.data));
  }, []);

  const save = async () => {
    setSaving(true);
    const { _id, ...payload } = s;
    await api.put("/admin/seo-settings", payload);
    toast.success("SEO settings saved");
    setSaving(false);
  };

  if (!s) return <p className="text-charcoal-500">Loading…</p>;
  const set = (k, v) => setS({ ...s, [k]: v });

  return (
    <div data-testid="admin-seo">
      <SectionTitle title="SEO" subtitle="Site-wide defaults used for search engines and social sharing (Open Graph / Twitter cards)." />
      <div className="space-y-6">
        <Card>
          <div className="space-y-4">
            <Field label="Site name" testid="seo-site-name" value={s.site_name} onChange={(v) => set("site_name", v)} />
            <Field label="Default title" testid="seo-default-title" value={s.default_title} onChange={(v) => set("default_title", v)} />
            <Area label="Default meta description" testid="seo-default-desc" value={s.default_description} onChange={(v) => set("default_description", v)} rows={3} />
            <Field label="Default social share image URL (Open Graph)" testid="seo-og-image" value={s.default_og_image} onChange={(v) => set("default_og_image", v)} />
            {s.default_og_image && <img src={s.default_og_image} alt="OG preview" className="h-32 w-full max-w-md rounded-xl object-cover border border-sand-200" />}
            <Field label="Keywords (comma-separated)" testid="seo-keywords" value={s.keywords} onChange={(v) => set("keywords", v)} />
            <Field label="Twitter handle (optional, e.g. @holamovers)" testid="seo-twitter" value={s.twitter_handle} onChange={(v) => set("twitter_handle", v)} />
          </div>
        </Card>
        <SaveButton testid="seo-save" onClick={save} saving={saving} />
      </div>
    </div>
  );
}
